import React from 'react';
import { FileOrFormQuestion } from '../FileOrFormQuestion';
import { usePropertySurveyFile } from '../../../../queries/PropertyFileFields/NonRentalFiles';

interface SurveyFileParameter {
    propertyGuid: string;
    required: boolean;
    isReview?: boolean;
}

export const SurveyFile: React.FC<SurveyFileParameter> = ({ required, propertyGuid, isReview = false }) => {
    const {
        handleMode,
        setHandleMode,
        filename: uploadFileName,
        setFilename: setUploadFileName,
        fileApiId: uploadedFileApiId,
        setFileApiId: setUploadedFileApiId,
    } = usePropertySurveyFile(propertyGuid);

    return (
        <div className='form-group'>
            <div className='row'>
                <FileOrFormQuestion
                    label='Survey'
                    selector='survey'
                    fileType={'survey'}
                    required={required}
                    isReview={isReview}
                    propertyGuid={propertyGuid}
                    handle={handleMode}
                    onHandleChange={setHandleMode}
                    uploadFileName={uploadFileName}
                    onUploadFileNameChange={setUploadFileName}
                    uploadedFileApiId={uploadedFileApiId}
                    onUploadedFileApiIdChange={setUploadedFileApiId}
                />
            </div>
        </div>
    );
};
